<div class="flex flex-col gap-y-4">
    <div class="w-full flex flex-row items-center justify-between">
        <p class="text-xl text-black ml-10 pt-2">{{ 'loading' | transloco }} ...</p>
        <fa-icon
            class="mr-4 cursor-pointer text-custom-dark-grey"
            size="xl"
            [icon]="['far', 'close']"
            [mat-dialog-close]="true" />
    </div>
    <app-progress-bar
        class="w-full m-auto"
        [itemsLoaded]="entitiesLoaded()"
        [total]="data.total" />
</div>
